/* @flow */

import classNames from 'classnames';
import { compose } from 'ramda';
import * as React from 'react';
import { createUseStyles } from 'react-jss';

import BaseIcon from 'src/shared/ui/component/icon/BaseIcon';
import styles from './CircledArrowIcon.style';

import svg from './circled-arrow.svg';

type Props = {
  className?: string,
  title?: string,
  // Self passed
};

const useStyles = createUseStyles(styles);

const CircledArrowIcon = ({ className, title }: Props): React.Node => {
  const classes: Object = useStyles();

  return (
    <BaseIcon
      className={classNames(classes.root, className)}
      svg={svg}
      title={title}
    />
  );
};

export default compose(React.memo)(CircledArrowIcon);
